/**
 * Position quantities (OMS-REQ-POS-001 / Q-POS-5).
 * Closing = Opening + Filled. Close+Orders = Opening + Filled + Working.
 * Unknown opening stays null. It is never treated as zero.
 */
export function omsPositionFigures(
  opening: number | null,
  filled: number,
  working: number,
): { closing: number | null; closePlusOrders: number | null } {
  if (opening == null) return { closing: null, closePlusOrders: null };
  const closing = opening + filled;
  return { closing, closePlusOrders: closing + working };
}

/**
 * Limit capacity (OMS-REQ-POST-002).
 * Over the soft limit only when Close+Orders and the soft limit are both known
 * and the absolute Close+Orders is above the soft limit.
 * Capacity is that limit minus the absolute quantity. Unknown limits stay null.
 */
export function omsLimitFigures(
  closePlusOrders: number | null,
  softLimit: number | null,
  hardLimit: number | null,
): { overSoftLimit: boolean; capacityToSoft: number | null; capacityToHard: number | null } {
  if (closePlusOrders == null || !Number.isFinite(closePlusOrders)) {
    return { overSoftLimit: false, capacityToSoft: null, capacityToHard: null };
  }
  const quantity = Math.abs(closePlusOrders);
  const soft = softLimit != null && Number.isFinite(softLimit) ? softLimit : null;
  const hard = hardLimit != null && Number.isFinite(hardLimit) ? hardLimit : null;
  return {
    overSoftLimit: soft != null && quantity > soft,
    capacityToSoft: soft == null ? null : soft - quantity,
    capacityToHard: hard == null ? null : hard - quantity,
  };
}
